import { NgxPopperjsModule } from 'ngx-popperjs';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkListboxModule } from '@angular/cdk/listbox';

import { DisabledDirective, TabIndexDirective } from '../utils';
import { ErrorStateMatcher } from '../forms';

import { SelectComponent } from './select.component';
import { SelectOptionDirective } from './select-option.directive';

@NgModule({
  exports: [
    SelectComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    NgxPopperjsModule,
    CdkListboxModule,
    SelectOptionDirective,
    TabIndexDirective,
    DisabledDirective,
    SelectComponent,
  ],
  providers: [
    ErrorStateMatcher,
  ],
})
export class SelectModule {}
